import { render, staticRenderFns } from "./DespachosDashBoardComponent.vue?vue&type=template&id=b7946208&"
import script from "./DespachosDashBoardComponent.vue?vue&type=script&lang=js&"
export * from "./DespachosDashBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports